import Vue from 'vue'
import { mapState } from 'vuex';
import Router from 'vue-router'
import store from '../store';  
import { userVipTime } from "@/api/index.js"
import { Message } from 'element-ui';
Vue.use(Router)

let router = new Router({  
    routes: [ 
        {  
        path: '/',  
        name: 'Login',  
        component: () => import('@/view/login')  
        },  
        {  
        path: '/login',  
        name: 'Login',  
        component: () => import('@/view/login')  
        },  
        // 废弃
        {  
            path: '/index',  
            // name: 'datacenter',  
            component: () => import('@/view/index'),  
            meta:{  
                requireAuth:true,
                isVip: true, // 添加 isVip 字段，标识该路由需要 VIP 权限 
            },
            children: [  
                {  
                    path: 'PriceTrenf',  
                    component: () => import('@/view/detail/PriceTrenf'),    
                },  
                {  
                    path: 'EnterpricePrice',  
                    component: () => import('@/view/detail/EnterpricePrice.vue'),   
                },  
                {  
                    path: 'marketPrice',  
                    component: () => import('@/view/detail/marketPrice.vue'),   
                },  
                {  
                    path: 'SalesProgress',  
                    component: () => import('@/view/detail/SalesProgress.vue'),   
                },  
                {  
                    path: 'PortPrice',  
                    component: () => import('@/view/detail/portPrice.vue'),   
                },  
                {  
                    path: 'soymealPrice',  
                    component: () => import('@/view/detail/soymealPrice.vue'),   
                },  
                {  
                    path: 'soyoilPrice',  
                    component: () => import('@/view/detail/soyoilPrice.vue'),   
                },  
                {  
                    path: 'matrixAuction',  
                    component: () => import('@/view/detail/matrixAuction.vue'),   
                },  
                {  
                    path: 'importPrice',  
                    component: () => import('@/view/detail/importPrice.vue'),   
                },  
                {  
                    path: 'importMarketQuotations',  
                    component: () => import('@/view/detail/importMarketQuotations.vue'),   
                },  
                {  
                    path: 'SupplyDemandDetail',  
                    component: () => import('@/view/detail/SupplyDemandDetail.vue'),   
                },  
            ],  
        }, 
        // 
        {
            path: '/pages',
            name:'pages',
            component: () => import('@/view/pages'),
            meta:{  
                requireAuth:true,
                isVip: true, // 添加 isVip 字段，标识该路由需要 VIP 权限 
            },
            children:[
                {  
                    path: 'Test',  
                    component: () => import('@/view/pages/Test'),    
                },  
                {  
                    path: 'pointPrice',  
                    component: () => import('@/view/pages/pointPrice'),    
                },  
                {  
                    path: 'portPrice',  
                    component: () => import('@/view/pages/portPrice'),    
                },  
                {  
                    path: 'matrixAuction',  
                    component: () => import('@/view/pages/matrixAuction'),    
                },  
                {  
                    path: 'minimumPrice',  
                    component: () => import('@/view/pages/minimumPrice'),    
                },  
                {  
                    path: 'importPrice',  
                    component: () => import('@/view/pages/importPrice'),    
                },  
                {  
                    path: 'customPrice',  
                    component: () => import('@/view/pages/customPrice'),    
                },  
                {  
                    path: 'importMarketQuotations',  
                    component: () => import('@/view/pages/importMarketQuotations'),    
                },  
                {  
                    path: 'supplyDemand',  
                    component: () => import('@/view/pages/supplyDemand'),    
                },  
                {  
                    path: 'salesProgress',  
                    component: () => import('@/view/pages/salesProgress'),    
                },  
                {  
                    path: 'plantCost',  
                    component: () => import('@/view/pages/plantCost'),    
                },  
                {  
                    path: 'matrixMachining',  
                    component: () => import('@/view/pages/matrixMachining'),    
                },  
                {  
                    path: 'programGrow',  
                    component: () => import('@/view/pages/programGrow'),    
                },  
                {  
                    path: 'portInventory',  
                    component: () => import('@/view/pages/portInventory'),    
                },  
                {  
                    path: 'programPort',  
                    component: () => import('@/view/pages/programPort'),    
                },  
                {  
                    path: 'FobPrice',  
                    component: () => import('@/view/pages/FobPrice'),   
                },  
                {  
                    path: 'forwardPrice',  
                    component: () => import('@/view/pages/forwardPrice'),   
                },  
                {  
                    path: 'forwardPriceDiff',  
                    component: () => import('@/view/pages/forwardPriceDiff'),   
                },  
                {  
                    path: 'EntMachining',  
                    component: () => import('@/view/pages/EntMachining'),   
                },  
                {  
                    path: 'importProfit',  
                    component: () => import('@/view/pages/importProfit'),   
                },  
            ],
        } 
    ]  
})  
// const whiteList = ["/login","/"];
// router.beforeEach(async (to, from, next) => {  
//     const token = localStorage.getItem('token');  
//     const isWhiteListed = whiteList.indexOf(to.path) !== -1;  
//     const isVip = store.state.isVip; 
//     console.log('vip状态',isVip);
//     if (token || isWhiteListed) {  
//         next();  
//     } else if (to.path === '/index' && !isVip) {  
//         next();  
//     } else if (to.matched.some(record => record.meta.requireAuth && isVip)) {  
//         try {  
//             const res = await userVipTime(); // 假设 userVipTime 返回一个 Promise  
//             console.log('userVipTime返回值',res);
//             if (res.data.code == 3000) {  
//                 next('/login');  
//             } else {  
//                 const cropInfo = res.data.result;  
//                 if (Object.keys(cropInfo).length !== 0) {  
//                     const filteredList = [];  
//                     for (const cropName in cropInfo) {  
//                         if (cropInfo[cropName] !== null && cropInfo[cropName] !== undefined) {  
//                             const foundItem = store.state.breedList.find(item => item.name === cropName);  
//                             if (foundItem) {  
//                                 filteredList.push(foundItem);  
//                             }  
//                         }  
//                     }  
//                     store.commit('getVipbreedList', filteredList);  
//                     next();
//                 } else {  
//                     Message.warning('没有Vip权限');
//                     next(false)  
//                 }  
//             }
//         } catch (err) {  
//             console.log(err);
//         } 
//         console.log('vip品种列表',store.state.vipbreedList); 
//     } else {  
//         next();
//     }  
// });
router.beforeEach(async (to, from, next) => {
    // console.log('路由拦截');  
    const token = localStorage.getItem('token');
    const isLoginPage = to.path === '/login' || to.path === '/';  
    const isIndexPage = to.path === '/index';  
    const requiresVip = !isLoginPage && !isIndexPage && to.matched.some(record => record.meta.isVip);  
    const requiresPageData = to.path.includes('/page');  
    // 跳转到login页面无需token  
    if (isLoginPage) {  
        next();
        return;  
    }
    let isVip = false; // 初始假设用户不是VIP  
    let vipData = null; // 存储VIP数据的变量  
    try {  
        const res = await userVipTime(); // 只调用一次接口  
        if(res.data.code === 3000){  
            Message.warning('登录过期');  
            next('/login'); // 重定向到登录页面  
            return; // 提前结束函数  
        } else if (res.data && res.data.code === 200) {  
            isVip = Object.keys(res.data.result).length !== 0;  
            vipData = res.data.result; // 存储VIP数据以便后续使用  
        } else {    
            Message.warning('请求vip数据失败,code:01');  
            return; // 提前结束函数  
        }  
    } catch (error) {  
        Message.error('网络错误或其他异常');  
        return; // 提前结束函数  
    }
    // 如果用户是VIP  
    if (isVip) {  
        if (requiresPageData) {    
            if (vipData) {  
                store.commit('getVipbreedList', vipData);   
                next();   
            } else { 
                Message.warning('VIP数据获取失败');  
            }  
        } else {    
            // 如果不是/page路由，直接跳转    
            next();    
        }    
    } else { 
        if(isIndexPage){
            next(); 
        }else{
            Message.warning('没有Vip权限');
            store.commit('setDialogTableVisible', true);
        }   
        // 如果需要VIP但不是VIP，重定向到登录页面或其他合适的页面    
         // 或者重定向到VIP升级页面等    
        // store.commit('setDialogTableVisible', true); //vip页面启动 
        // next('/nonVipPage'); // 或其他非VIP页面  
    }  
    // 如果不需要VIP，则直接跳转  
    // else if (!requiresVip) {  
    //     next();  
    // }else if(requiresVip){
    //     // 这次请求用于获取是否为vip
    //     const res = await userVipTime();
    //     if(res.data.code === 3000){
    //         Message.warning('登录过期');
    //         // next('/login');
    //     }else if (res.data && res.data.code === 200) {
    //         store.state.isVip = Object.keys(res.data.result).length !== 0;
    //     } else {  
    //         // 处理错误情况，比如重定向到错误页面或提示用户  
    //         Message.warning('请求vip数据失败,code:01');
    //     }
    //     let isVip = store.state.isVip;
    //     if (isVip) {  
    //         if (requiresPageData) {  
    //             // 这次请求获取vip的品种列表
    //             const res = await userVipTime();
    //             if(res.data && res.data.code === 200){
    //                 store.commit('getVipbreedList', res.data.result); 
    //                 next(); 
    //             }else{
    //                 Message.warning('请求vip数据失败,code:02');
    //             }
    //         } else {  
    //         // 如果不是/page路由，直接跳转  
    //             next();  
    //         }  
    //     }  
    //     // 如果需要VIP但不是VIP，重定向到登录页面或其他合适的页面  
    //     else {  
    //         Message.warning('没有Vip权限'); // 或者重定向到VIP升级页面等  
    //         store.commit('setDialogTableVisible', true);
    //     }
    // }
    });
export default router;